<template>
  <v-container fluid class="px-0">
    <div class="profile-page">
      <v-row>
        <v-col md=6 sm="6" cols=12>
          <v-row>
            <v-col cols="12" v-if="this.profile_data!=''">
              <v-card class="user-card ma-1" min-height="282">
                <v-card-text class="pa-5 pt-9 fill-height">
                  <v-row no-gutters class="fill-height">
                    <v-col cols="12" sm="5" xl="6" class="d-flex justify-center align-center flex-column">
                      <div
                          class="avatar-wrapper">
                        <v-img
                            class="user-avatar"
                            contain
                            :src="baseURLStorage+this.profile_data.avatarFile"></v-img>
                      </div>
                      <v-chip
                          small
                          class="mr-2 mt-4 mb-4 mb-sm-0"
                          color="error"
                      >{{ this.profile_data.role=='admin'?"Manager":"User" }}
                      </v-chip>
                    </v-col>
                    <v-col cols="12" sm="7" xl="6" class="pl-0 pl-sm-4 d-flex flex-column align-center align-sm-start">
                      <p class="user-name greyMedium--text font-weight-regular"> {{ this.profile_data.fname_th }}
                        {{ this.profile_data.lname_th }}</p>
                      <p class="user-work greyTint--text ma-0">{{ this.profile_data.fname_en }}
                        {{ this.profile_data.lname_en }}</p>
                      <a class="body-1"> {{ this.profile_data.email }}</a>
                      <a class="body-1"> {{ this.profile_data.phone_number }}</a>
                      <div class="d-flex justify-center justify-sm-start flex-wrap mt-5">
                        {{ this.profile_data.job_title }}
                      </div>

                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>


          </v-row>
          <v-row>
            <v-col cols="12">
              <v-card class="folder-card ma-1" min-height="282">
                <v-card-title class="pa-5 pb-3">

                  <p>รายการ </p>
                </v-card-title>
                <v-card-text class="pa-5 pt-0">
                  <v-tabs color="secondary">
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab
                        v-for="(tab, i) in mock.tabequipments"
                        class="text-capitalize font-weight-regular"
                        :key="i"
                        :href="'#tab-' + tab.tabName.toLocaleLowerCase()">
                      {{ tab.tabName }}
                    </v-tab>
                    <v-tab-item
                        v-for="(tab, i) in mock.tabequipments"
                        :key="i"
                        :value="'tab-' + tab.tabName.toLocaleLowerCase()"
                        class="pb-0 pb-sm-3 pb-lg-0"
                    >
                      <v-divider></v-divider>
                      <v-row justify-xl="space-around" justify="start"
                             class="d-flex flex-nowrap overflow-x-auto pa-4 pt-5">
                        <div
                            v-for="(items, i) in e_borrowing_status_count"
                            :key="i">
                          <a :href="borrowing_status_text_color.find(item => item.status_code === items.borrowing_status).url">
                            <v-img
                                :src="$vuetify.theme.dark ? borrowing_status_text_color.find(item => item.status_code === items.borrowing_status).srcDark : borrowing_status_text_color.find(item => item.status_code === items.borrowing_status).src"
                                width="141" height="106" contain
                                class="folder-image mr-3"
                            >
                              <p class="folder-title" style="bottom:18px"> {{borrowing_status_text_color.find(item => item.status_code === items.borrowing_status).title_th}}</p>
                              <p class="folder-subtitle-1 font-weight-medium" style="font-size:30px"> {{
                                  items.count_borrowing_id
                                }} </p>
                            </v-img>
                          </a>
                        </div>
                      </v-row>
                    </v-tab-item>
                  </v-tabs>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>

        <v-col md=6 sm="6" cols=12>
          <v-row>
            <v-col cols="12" md="12" v-if="this.equipment_type_master_sum!=''">
              <v-card class="media-card ma-1" min-height="595">
                <v-card-title class="pa-5 pb-3">
                  <p>วัสดุอุปกรณ์ที่ให้บริการ</p>
                  <v-spacer></v-spacer>


                </v-card-title>
                <v-card-text class="pa-5 pb-0 pt-5">
                  <v-row no-gutters class="pb-6">

                    <v-col cols="4" class="d-flex align-center flex-column" v-for="item in equipment_type_master_sum"
                           :key="item.item_type_master_code">
                      <v-img :src="require('@/assets/img/user/profile/media/posts.svg')" height="40" width="40"></v-img>
                      <p class="greyBold--text text-h6 mb-n2">{{ item.item_quantity }}</p>
                      <p class="media-subtitle"><b>{{ item.item_type_master_name }}</b></p>
                    </v-col>

                  </v-row>
                </v-card-text>
                <v-col cols="12" class="d-flex flex-column align-end mt-3 pe-10">

                  <v-btn
                      href="/#/erbr/equipment_list"
                      color="primaryConst"
                      outlined
                  >วัสดุอุปกรณ์ทั้งหมด
                  </v-btn>
                </v-col>
              </v-card>
            </v-col>

          </v-row>


        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import mock from './mock'
import config from "@/config"
import ApexChart from 'vue-apexcharts'
import axios from "axios";
import {mapState} from "vuex";


export default {
  name: 'EquipmentProfileView',
  components: {
    ApexChart
  }
  ,
  computed: {
    // map state ใน Store ของเราเข้ามาเป็น Computed * เข้ามาเป็นตัวแปร

    ...mapState('auth', {
      currentUser: (state) => state.currentUser,
    }),
  },
  data() {
    return {
      baseURLStorage: config.baseURLStorage,
      mock,
      config,
      arrayEvents: null,
      picker: new Date().toISOString().substr(0, 10),
      profile_data: '',
      equipment_type_master_sum: '',
      e_borrowing_status_count: '',
      borrowing_status_text_color: [
        {
          "status_code": "RR",
          "title_th": "รอรับรอง/รอเสนอ",
          src: require('@/assets/img/user/profile/folder-blue.svg'),
          srcDark: require('@/assets/img/user/profile/folder-dark-blue.svg'),
          url:'#/erbr/equipment_borrowing_returning'

        },
        {
          "status_code": "RN",
          "title_th": "ไม่รับรอง",
          src: require('@/assets/img/user/profile/folder-yellow.svg'),
          srcDark: require('@/assets/img/user/profile/folder-dark-yellow.svg'),
          url:'#/erbr/equipment_borrowing_returning'

        },
        {
          "status_code": "AC",
          "title_th": "รับรองแล้ว",
          src: require('@/assets/img/user/profile/folder-blue.svg'),
          srcDark: require('@/assets/img/user/profile/folder-dark-blue.svg'),
          url:'#/erbr/equipment_borrowing_returning'
        },
        {
          "status_code": "PA",
          "title_th": "อยู่ระหว่างเสนอ",
          src: require('@/assets/img/user/profile/folder-blue.svg'),
          srcDark: require('@/assets/img/user/profile/folder-dark-blue.svg'),
          url:'#/erbr/equipment_borrowing_returning'
        },
        {
          "status_code": "AN",
          "title_th": "ไม่อนุมัติ",
          src: require('@/assets/img/user/profile/folder-yellow.svg'),
          srcDark: require('@/assets/img/user/profile/folder-dark-yellow.svg'),
          url:'#/erbr/equipment_borrowing_returning'
        },
        {
          "status_code": "AP",
          "title_th": "อนุมัติแล้ว",
          src: require('@/assets/img/user/profile/folder-blue.svg'),
          srcDark: require('@/assets/img/user/profile/folder-dark-blue.svg'),
          url:'#/erbr/equipment_borrowing_returning'
        },
        {
          "status_code": "PE",
          "title_th": "เตรียมอุปกรณ์",
          src: require('@/assets/img/user/profile/folder-blue.svg'),
          srcDark: require('@/assets/img/user/profile/folder-dark-blue.svg'),
          url:'#/erbr/equipment_borrowing_returning'
        },
        {
          "status_code": "PS",
          "title_th": "เตรียมเสร็จ",
          src: require('@/assets/img/user/profile/folder-blue.svg'),
          srcDark: require('@/assets/img/user/profile/folder-dark-blue.svg'),
          url:'#/erbr/equipment_borrowing_returning'
        },
        {
          "status_code": "RC",
          "title_th": "รับแล้ว",
          src: require('@/assets/img/user/profile/folder-blue.svg'),
          srcDark: require('@/assets/img/user/profile/folder-dark-blue.svg'),
          url:'#/erbr/equipment_borrowing_returning'

        },
        {
          "status_code": "RT",
          "title_th": "คืนแล้ว",
          src: require('@/assets/img/user/profile/folder-green.svg'),
          srcDark: require('@/assets/img/user/profile/folder-dark-green.svg'),
          url:'#/erbr/equipment_borrowing_returning'

        },
        {
          "status_code": "ER",
          "title_th": "มีข้อผิดพลาด",
          src: require('@/assets/img/user/profile/folder-pink.svg'),
          srcDark: require('@/assets/img/user/profile/folder-dark-pink.svg'),
          url:'#/erbr/equipment_borrowing_returning'

        },
        {
          "status_code": "CX",
          "title_th": "ยกเลิก",
          src: require('@/assets/img/user/profile/folder-pink.svg'),
          srcDark: require('@/assets/img/user/profile/folder-dark-pink.svg'),
          url:'#/erbr/equipment_borrowing_returning'

        }
      ],
    }
  },
  methods: {
    async getEquipmentProfileData() {

      try {

        await axios.get(config.baseURLApi + '/api/getEquipmentProfileData', '', {
          headers: {},
        }).then(res => {

          this.profile_data = res.data[0];
        });


      } catch (e) {
        this.showSnackbar(e);
      }
    },
    async getEquipmentTypeMasterSum() {

      try {

        await axios.get(config.baseURLApi + '/api/getEquipmentTypeMasterSum', '', {
          headers: {},
        }).then(res => {

          this.equipment_type_master_sum = res.data;
        });

      } catch (e) {
        this.showSnackbar(e);
      }
    },
    async getEBorrowingStatusCount() {

      try {

        await axios.get(config.baseURLApi + '/api/getEBorrowingStatusCount', '', {
          headers: {},
        }).then(res => {

          this.e_borrowing_status_count = res.data;
         // console.log( res.data)
        });

      } catch (e) {
        this.showSnackbar(e);
      }
    },
    bgStyle: function (color) {
      const [r, g, b] = color;
      return {
        backgroundColor: `rgba(${r},${g},${b}, 0.2)`
      };
    },

    prev() {
      this.$refs.calendar.prev()
    },
    next() {
      this.$refs.calendar.next()
    },
    dateFunctionEvents(/*date*/) {
      // const [,, day] = date.split('-')
      // if ([12, 17, 28].includes(parseInt(day, 10))) return true
      // if ([1, 19, 22].includes(parseInt(day, 10))) return ['successConst', 'secondaryConst']
      return false
    },
  },
  mounted() {
    setTimeout(() => {
          this.apexLoading = true
        }
    )

    this.getEquipmentProfileData();
    this.getEquipmentTypeMasterSum();
    this.getEBorrowingStatusCount();

  }
}
</script>

<style src="./EquipmentProfile.scss" lang="scss"/>
